import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import AppRoutes from './routes/AppRoutes';
import AuthInitializer from './components/AuthInitializer';
import NotificationContainer from './components/NotificationContainer';
import store from './store';
import './App.css';

export default function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AuthInitializer>
          <AppRoutes />
          <NotificationContainer />
        </AuthInitializer>
      </BrowserRouter>
    </Provider>
  );
}
